export default __webpack_public_path__ + "static/media/invite-referees.77fc86b7.svg";